<template>
    <div
        class="o-background"
        ref="background"
    >
        <img
            class="o-background__image o-background__image--1"
            src="@/assets/1.png"
            alt=""
        >
        <img
            class="o-background__image o-background__image--2"
            src="@/assets/2.png"
            alt=""
            :style="`transform: translateX(calc( 15px * var(--l-background-x))) translateY(calc( 15px * var(--l-background-y)))`"
        >
        <img
            class="o-background__image o-background__image--3"
            src="@/assets/3.png"
            alt=""
            :style="`transform: translateX(calc( 40px * var(--l-background-x))) translateY(calc( 40px * var(--l-background-y)))`"
        >
    </div>
</template>

<script>
export default {
    methods: {
        handleMouse(getCurrentPos) {
            const xCord = getCurrentPos.clientX
            const yCord = getCurrentPos.clientY
            if(this.$refs.background) {
                this.$refs.background.style.setProperty('--l-background-x', xCord / window.innerWidth - 0.5)
                this.$refs.background.style.setProperty('--l-background-y', -yCord / window.innerHeight - 0.5)
            }
        }
    },
    mounted() {
        if(this.$refs.background) {
            window.addEventListener('mousemove', this.handleMouse)
        }
    },
    destroyed () {
        window.removeEventListener('mousemove', this.handleMouse)
    }
}
</script>
